// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import { AppLayoutProps } from '@cloudscape-design/components/app-layout';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
// @ts-ignore: TS2614
import { AppLayoutToolbar, Box, Button, Container, FileUpload, Flashbar, FlashbarProps, Form, FormField, Header, Input, Link, List, Modal, Select, SpaceBetween, Textarea, TextContent } from '@cloudscape-design/components';
import Badge from '@cloudscape-design/components/badge';
import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { mdiAlert, mdiBugStopOutline, mdiWeatherCloudyArrowRight } from '@mdi/js';
import Icon from '@mdi/react';
import ReactJsonView from '@microlink/react-json-view';
import { format } from 'date-fns';
import config from '../../../scripts/config.json';
import '../../components/css/override.css';
import { fetchWithWatch } from '../../hooks/fetchWithWatch';
import { MenuItem, scrollToTop } from '../../resources/types';
import '../../styles/base.scss';
import {
  addNotification, fileToBase64, getAirport, getCookie, getUrlVersion, resizeBase64Image, saveMasters, setCookie,
  setData,
  setIdAirport, setIdUser, setMenu,
  setName,
  setParameters,
  storeJWT
} from '../commons/functions';
import { LoadingOverlay } from '../commons/LoadingOverlay'; // Example corrected path
import { useGlobalState } from '../context/GlobalStateContext';
import { useLogger } from '../context/LoggerContext';
type BadgeColor =
  | "blue"
  | "grey"
  | "green"
  | "red"
  | "severity-critical"
  | "severity-high"
  | "severity-medium"
  | "severity-low"
  | "severity-neutral";

type ItemBugReport = {
  bug: string;
  route: string;
  parameters: any;
  idUser: number;
  jsonImages: any[];
  eventLog: any[];
  version: string;
}
interface CustomAppLayoutProps extends AppLayoutProps {
  // initialHelpPanelPage: string; // Removed this line
}

interface DemoHeaderPortalProps {
  children: ReactNode;
}

const DemoHeaderPortal = ({ children }: DemoHeaderPortalProps) => {
  const domNode = document.querySelector('#h')!;
  return createPortal(children, domNode);
};

interface CustomSection extends SideNavigationProps.Section {
  section?: string;
  items: readonly SideNavigationProps.Item[]; // Match the exact type (required + readonly)
}

function sectionHasActiveLink(section: any, hash: string): boolean {
  let part = (hash.split("/")[0]);
  if (section && section.href && section.href.startsWith(part)) return true;
  if (section && section.section && section.section.startsWith(part)) return true;


  return false;
}

export function CustomAppLayout({ ...props }: CustomAppLayoutProps) {

  const { idUser, data, menu, parameters, version, loading, name, user, idAirport } = useGlobalState();

  const { logHistory } = useLogger();



  //const { state, actions, appLayoutRef } = useStore();
  const [idUserTemp, setIdUserTemp] = useState(0);
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [showUserChoose, setShowUserChoose] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentHash, setCurrentHash] = useState(window.location.hash);
  const [showNavigation, setShowNavigation] = useState(true);
  const [showBugReport, setShowBugReport] = useState(false);
  const [bugError, setBugError] = useState("");
  const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
  const [bugReport, setBugReport] = useState<ItemBugReport | null>(null);





  const handleBugReport = async () => {
    try {
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/profile/bugreport',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify(bugReport),
      });

      if (response && !response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      if (response) {
        const dataTmp = await response.json();
        if (dataTmp.code === 0) {
          setBugReport({ bug: "", route: getHashPath(window.location.hash), parameters: parameters, eventLog: logHistory, idUser: idUser, jsonImages: [], version: config.version })
          setShowBugReport(false);
        }
      }

    } catch (error: any) {
      console.error(error);
    } finally {
    }
  };

  useEffect(() => {
    if (Object.keys(menu).length > 0) {
      // Recursive function to get all hrefs
      const getAllHrefs = (items: MenuItem[]): string[] => {
        return items.flatMap(item => {
          const childHrefs = item.items ? getAllHrefs(item.items) : [];
          return item.href ? [item.href, ...childHrefs] : childHrefs;
        });
      };

      const hrefs = getAllHrefs(menu);
      // && !window.location.hash.endsWith("/default")
      const hash = "#" + getHashPath(window.location.hash);
      if (hash == "#" || hash == "") {
        window.location.hash = "#home"
        return;
      }

      if (
        hrefs.indexOf(hash) === -1 &&
        !hash.includes("page404") &&
        !hash.includes("user/")
      ) {
        window.location.hash = "#page404?route=" + hash;
      }
    }
  }, [menu]);


  useEffect(() => {

  }, [data]);
  const profileActions = [
    {
      id: 'preferences', text: 'Preferencias',

      items: [
        {
          id: 'password',
          text: 'Modificar contraseña',
          href: '#user/password',
        },
        {
          id: 'profilr',
          text: 'Mi perfil',
          href: '#user/profile',
        },
        {
          id: 'masters',
          text: 'Actualizar maestros',
        },
        {
          id: 'bugs',
          text: 'Notificar BUG',
        },
        {
          id: 'clear-alerts',
          text: 'Limpiar alertas',
        },
        {
          id: 'update',
          text: (
            <SpaceBetween direction="horizontal" size="s">
              <Box>Versión {config.version}</Box>
              {/* {serverVersion > config.version && (
                <Badge color="red">
                  <Icon path={mdiAutoUpload} size={1} /> {serverVersion}
                </Badge>
              )} */}
            </SpaceBetween>
          ),
          href: '/',
        },
      ]
    },
    /*
    {
      id: 'support-group',
      text: 'Administración',

      items: [
        {
          id: 'users',
          text: 'Usuarios',
          href: '#admin/users',
        },
        idUser > 0 && { //  
          id: 'support-group',
          type: "button",
          text: "Propiedades",
          href: '#admin/properties?returnURL=' + (window.location.hash || '#home'),
          badge: true
        },

      ].filter(Boolean),

    },
    */
    { id: 'signout', text: 'Cerrar Sesión', href: '#user/logoff' },
  ];
  useEffect(() => {
    if (parameters) {
      if (parameters.isClosed === undefined) {
        setParameters({ ...parameters, isClosed: -1 });
      }
      if (parameters.year === undefined) {
        setParameters({ ...parameters, year: new Date().getFullYear() });
      }
      if (parameters.month === undefined) {
        setParameters({ ...parameters, month: new Date().getMonth() + 1 });
      }
      if (parameters.period === undefined) {
        setParameters({ ...parameters, period: format(new Date(), 'yyyy//MM') });
      }
      if (parameters.date === undefined) {
        setParameters({ ...parameters, date: format(new Date(), 'dd-MM-yyyy') });
      }
      if (parameters.pageSize === undefined) {
        setParameters({ ...parameters, pageSize: 20 });
      }
      if (parameters.idCategories === undefined) {
        setParameters({ ...parameters, idCategories: [] });
      }
      if (parameters.idGroupTypes === undefined) {
        setParameters({ ...parameters, idGroupTypes: [] });
      }
      if (parameters.idFlightTypes === undefined) {
        setParameters({ ...parameters, idFlightTypes: [] });
      }
      if (parameters.idGroups === undefined) {
        setParameters({ ...parameters, idGroups: [] });
      }
      if (parameters.idStatuses === undefined) {
        setParameters({ ...parameters, idStatuses: [] });
      }
      if (parameters.idCharges === undefined) {
        setParameters({ ...parameters, idCharges: [] });
      }
      if (parameters.idChecks === undefined) {
        setParameters({ ...parameters, idChecks: [] });
      }
      if (parameters.idUserTypes === undefined) {
        setParameters({ ...parameters, idUserTypes: [] });
      }
      if (parameters.intersection === undefined) {
        setParameters({ ...parameters, intersection: false });
      }
      if (parameters.idUser === undefined) {
        setParameters({ ...parameters, idUser: 0 });
      }
      if (parameters.direction === undefined) {
        setParameters({ ...parameters, direction: "BOTH" });
      }

    }
  }, [parameters]);
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event && event.key) {
        const ctrl = event.ctrlKey;
        const alt = event.altKey;
        const key = event.key.toLowerCase();

        if (ctrl && alt && key === 'u') {
          console.log('Ctrl + Alt + U pressed');
          setShowUserChoose(true);
        }

        if (ctrl && alt && key === 'l') {
          console.log(logHistory);
        }
        if (ctrl && alt && key === 'd') {
          console.log(data);
        }

        if (ctrl && alt && key === 'm') {
          //
        }

        if (ctrl && alt && key === 'p') {
          console.log(parameters);
        }
      };
    };

    // Add the listener
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup when component unmounts or dependencies change
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [data, parameters]);


  const globalState = useGlobalState();


  const handleMarkRead = async (idMessage: number) => {
    try {
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/login/data',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({
          idMessage: idMessage
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const dataTmp = await response.json();

      if (dataTmp.code == 0) {
        if (dataTmp.oJWT) {
          if (dataTmp.oJWT.valid === false || dataTmp.oJWT.expired === true) {
            setCookie("JWT", "")
            storeJWT(dataTmp)
            if (!window.location.hash.startsWith("#user/")) {
              console.log("JWT expired, redirect to login")
              setIdUser(0); setIdAirport(0);
              window.location.href = '#user/login'
              return;
            }
          }
        }
        if (dataTmp.JWT && dataTmp.JWT === "") {
          if (!window.location.hash.startsWith("#user/")) {
            console.log("No JWT, redirect to login")
            setIdUser(0); setIdAirport(0);
            window.location.href = '#user/login'
            return;
          }
        }
        setCookie("JWT", dataTmp.JWT)
        storeJWT(dataTmp)
        if (dataTmp.menu && dataTmp.menu.length > 0 && JSON.stringify(menu) !== JSON.stringify(dataTmp.menu)) {
          //console.log("Change Menu")
          setMenu(dataTmp.menu);
          localStorage.setItem("menu", JSON.stringify(dataTmp.menu));
          //window.location.reload()
        }
        if (dataTmp.UF && dataTmp.USD) {
          const updatedData = { ...data, UF: Number(dataTmp.UF), USD: Number(dataTmp.USD) };
          setData(updatedData);
        }
        if (dataTmp.counters) {
          const updatedData = { ...data, counters: dataTmp.counters };
          setData(updatedData);
        }

      }
      //http://[::1]:9615/#ops/mercenaries/pax?id=342747

      let currentHash = (window.location.hash).replace("#", "") || '';

      if (!window.location.hash.startsWith("#user/")) {
        if (dataTmp.codeLogin && dataTmp.codeLogin == -1) {
          console.log("Invalid login, redirect to login");

          setIdUser(0); setIdAirport(0);
          window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
          return;
        } else if (dataTmp.JWT === "") {
          console.log("2A.-No JWT, redirect to login");

          setIdUser(0); setIdAirport(0);
          window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
          return;
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
    }
  };

  /*
    useEffect(() => {
  
      const handleFocus = async () => {
        try {
          const response = await fetch(`${getUrlVersion()}/routing/v1/?session2`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-routing': '/private/user/login/data',
              'JWT': getCookie("JWT"),
            },
            body: JSON.stringify({
              //masters:true
            }),
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
          }
  
          const dataTmp = await response.json();
  
          if (dataTmp.code == 0) {
            if (dataTmp.oJWT) {
              if (dataTmp.oJWT.valid === false || dataTmp.oJWT.expired === true) {
                setCookie("JWT", "")
                storeJWT(dataTmp)
                if (!window.location.hash.startsWith("#user/")) {
                  console.log("JWT expired, redirect to login")
  
                  setIdUser(0); setIdAirport(0);
                  window.location.href = '#user/login'
                  return;
                }
              }
            }
            if (dataTmp.JWT && dataTmp.JWT === "") {
              if (!window.location.hash.startsWith("#user/")) {
                console.log("No JWT, redirect to login")
  
                setIdUser(0); setIdAirport(0);
                window.location.href = '#user/login'
                return;
              }
            }
            setCookie("JWT", dataTmp.JWT)
            storeJWT(dataTmp)
  
            if (dataTmp.menu && dataTmp.menu.length > 0) {
              if (JSON.stringify(menu) !== JSON.stringify(dataTmp.menu)) {
                localStorage.setItem("menu", JSON.stringify(dataTmp.menu));
                setMenu(dataTmp.menu);
              }
              //window.location.reload()
            }
  
            if (dataTmp.airports) {
              const ap = dataTmp.airports ? dataTmp.airports.map((airport: any) => ({ value: airport.idAirport.toString(), label: `${airport.city} - ${airport.IATA}` })) : []
              const updatedData = { ...data, userAirports: ap };
              //console.log(ap)
              //setData(updatedData);
  
            }
  
          }
          //http://[::1]:9615/#ops/mercenaries/pax?id=342747
  
          let currentHash = (window.location.hash).replace("#", "") || '';
  
          if (!window.location.hash.startsWith("#user/")) {
            if (dataTmp.codeLogin && dataTmp.codeLogin == -1) {
              console.log("Invalid login, redirect to login");
              setIdUser(0); setIdAirport(0);
              window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
              return;
            } else if (dataTmp.JWT === "") {
              console.log("2B.-No JWT, redirect to login");
              setIdUser(0); setIdAirport(0);
              window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
              return;
            }
          }
          if (data.userAirports) {
            setData((prev: any) => {
              const updated = {
                ...prev,
                userAirports: dataTmp.userAirports
              };
              localStorage.setItem("data", JSON.stringify(updated));
  
              return updated;
            });
          }
        } catch (error: any) {
          console.error(error);
        } finally {
        }
      };
  
      window.addEventListener('focus', handleFocus);
  
      // Cleanup when the component unmounts
      return () => {
        window.removeEventListener('focus', handleFocus);
      };
    }, []);
  */
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setNavigationOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const onHashChange = () => setCurrentHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash //getHashPath(window.location.hash);
      let show = true;
      show = !hash.startsWith('#user/') && !hash.startsWith('samples/')
      if (hash.startsWith('#user/profile') || hash.startsWith('#user/password')) show = true
      if (hash.indexOf("/default") > 0) show = true
      setShowNavigation(show)
      //setShowNavigation(!hash.startsWith('user/') && !hash.startsWith('samples/') && hash!='user/profile' && hash!='user/password');
    };

    handleHashChange(); // run initially
    window.addEventListener('hashchange', handleHashChange);

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const [navItems, setNavItems] = useState<SideNavigationProps.Item[]>([]);
  const handleExpand = (indexToExpand: number) => {
    //console.log(indexToExpand)
  }

  useEffect(() => {
    //console.log(menu)
  }, [data]); //pendingAuth, invoicesExpired
  const filterSideMenu = (items: any[]): any[] => {
    return items
      .map((item) => {
        const showItem = item.isSideMenu !== 0;
        const children = item.items ? filterSideMenu(item.items) : [];

        if (showItem || children.length > 0) {
          return {
            ...item,
            type: item.type || "link", // <- ensure type exists
            items: children.length > 0 ? children : item.items ? item.items.map((ci: any) => ({ ...ci, isSideMenu: 1, type: ci.type || "link" })) : [],
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    if (!menu || Object.keys(menu).length === 0) return;

    const fetchNav = async () => {
      const filteredData = filterSideMenu(menu);

      const badgeData: Record<string, number> = {};

      const processedNav = filteredData.map((item, index) => ({
        ...item,
        items: item.items?.map((subItem: any) => ({
          ...subItem,
          info:
            subItem.badge &&
              subItem.badgeVariable &&
              badgeData[subItem.badgeVariable] > 0 ? (
              <Badge color={subItem.badgeColor as BadgeColor || "blue"}>
                {badgeData[subItem.badgeVariable]}
              </Badge>
            ) : undefined,
        })),
        defaultExpanded: sectionHasActiveLink(item, window.location.hash),
        onChange: handleExpand(index),
      }));

      setNavItems(processedNav || []);
    };

    fetchNav();
  }, [menu]);




  const navRef = useRef(null);
  const handleChangeAirport = async (idApt: number) => {
    if (idApt && idApt > 0) {
      try {
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/user/airport',
            'JWT': getCookie("JWT"),
          },

          body: JSON.stringify({ idAirport: idApt, masters: true })
        });
        if (response && !response.ok) { throw new Error(`HTTP error: ${response.status}`); }
        if (response) {
          const dataWeb = await response.json();
          if (dataWeb && dataWeb.code === 0) {


            setCookie("JWT", dataWeb.JWT);
            setData(saveMasters(dataWeb, data))
            setIdUser(dataWeb.idUser);
            setName(dataWeb.name);
            setIdAirport(dataWeb.idAirport);
            localStorage.setItem('idAirport', dataWeb.idAirport.toString());


            const timer = setTimeout(() => {
              addNotification("Aeropuerto cambiado a " + getAirport(dataWeb.idAirport, data).city + " - " + getAirport(dataWeb.idAirport, data).IATA, 'info', setData);
              scrollToTop();
            }, 500);
            return () => clearTimeout(timer);
          }
        }

      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {

      }
    }
  }
  const handleSetUserTemp = async () => {
    try {
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/charges/list',
          'JWT': getCookie("JWT"),
        },

        body: JSON.stringify({ idUserTemp: idUserTemp })
      });
      if (response && !response.ok) { throw new Error(`HTTP error: ${response.status}`); }
      if (response) {

        const data = await response.json();
        if (data) {
          setShowUserChoose(false)
          setIdUser(data.idUser);
          setName(data.name);
          setCookie("JWT", data.JWT);
          window.location.reload()
        }
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {

    }
  }

  useEffect(() => {
    if (idUserTemp && idUserTemp > 0)
      handleSetUserTemp()
  }, [idUserTemp]);

  interface UtilityItem {
    id: string;
    text: React.ReactNode;
    href: string;
    description: React.ReactNode;
    content: React.ReactNode;
  }

  function collectFavorites(items: MenuItem[], parents: string[] = []): any[] {
    let favorites: UtilityItem[] = [];

    items.forEach((item) => {
      const routeParts = [...parents]; // Only parents, exclude current item

      if (item.isFavorite === 1) {
        favorites.push({
          id: `favorite-${item.idMenu}`,
          //text: (<div style={{ width: 200 }}><FormField label={item.text}>{routeParts.join(" > ")}</FormField></div>),
          text: item.text,
          content: item.text,
          href: item.href ?? "#",
          description: (<small>{routeParts.join(" > ")}</small>),

        });
      }

      if (item.items && item.items.length > 0) {
        favorites.push(...collectFavorites(item.items, [...parents, item.text]));
      }
    });

    return favorites;
  }



  let utilities: any = []
  const favorites = collectFavorites(menu);

  if (getCookie("JWT") !== "") {

    if (favorites && favorites.length > 0) utilities.push(

      {

        type: "menu-dropdown" as const,
        iconName: "heart-filled",
        items: [

          {
            id: "ID",
            text: (<h3>Favoritos</h3>),
          },

          {

            id: "ID2",
            text: (<div style={{ width: 200 }}>

              <List
                ariaLabel="Simple list"
                items={favorites}

                renderItem={({ id, content, description, href }) => ({
                  id,
                  content: (
                    <div style={{ cursor: "pointer" }} onClick={() => window.location.hash = (href)}>
                      {content}
                    </div>
                  ),
                  secondaryContent: (
                    <div style={{ cursor: "pointer" }} onClick={() => window.location.hash = (href)}><Box>{description}</Box></div>
                  )
                })}
              />
            </div>),
            description: "DESC",
          },
        ],
      }
    )


    utilities.push({
      type: "menu-dropdown" as const,
      text: "",
      iconName: "user-profile",
      items: profileActions,
      onItemClick: (event: any) => {
        if (event.detail.id === "signout") {
          window.location.href = "#user/logout";
        }
        if (event.detail.id === "masters") {
          //handleMasterDownload()
        }
        if (event.detail.id === "clear-alerts") {
          setData((prev: any) => {
            const reset = { ...prev, notifications: [] };
            localStorage.setItem("data", JSON.stringify(reset));
            return reset;
          });
        }
        if (event.detail.id === "bugs") {

          setBugReport({ bug: "", route: getHashPath(window.location.hash), parameters: parameters, eventLog: logHistory, idUser: idUser, jsonImages: [], version: config.version })
          setShowBugReport(true);
        }
      },
    });

  }
  const flashbarItems = (data.notifications || []).map((n: any) => ({
    id: n.id,
    content: n.content,
    type: n.type,
    dismissible: true,
    onDismiss: () => {
      setData((prev: any) => {
        const filtered = prev.notifications.filter((item: any) => item.id !== n.id);
        const updatedData = { ...prev, notifications: filtered };
        localStorage.setItem("data", JSON.stringify(updatedData));
        return updatedData;
      });
    }
  }));
  const customStyles = `
    [class*="awsui_page-item_"] li {
      margin: 0 !important;
      padding: 0 !important;
    }`;

  const [files, setFiles] = React.useState<File[]>([]);


  const handleFileChange = async (files: File[]) => {
    if (!bugReport) return;

    const base64Results = await Promise.all(files.map(fileToBase64));
    const resizedResults = await Promise.all(
      base64Results.map(async (result) => {
        const base64WithPrefix = result.base64.startsWith("data:")
          ? result.base64
          : `data:${result.file.type};base64,${result.base64}`;
        const resizedBase64 = await resizeBase64Image(base64WithPrefix, 800, 0.7);
        const cleanedBase64 = resizedBase64.replace(/^data:image\/\w+;base64,/, "");


        return {
          fileName: result.file.name,
          fileContent: cleanedBase64,
          fileSize: result.file.size
        };
      })
    );
    console.log(resizedResults)
    setBugReport((prev: ItemBugReport | null) => {
      if (!prev) return prev;
      return {
        ...prev,
        // Use the spread operator on the entire new array to append all new files
        jsonImages: resizedResults
      };
    });
    //} catch (error) {
    //   console.error('Error reading files:', error);
    // Handle error state if necessary
    //}
  };

  let visibleUtilities = [...utilities];

  const isUpdateAvailable = (current: string, available: string) => {
    const v1 = current.split('.').map(Number);
    const v2 = available.split('.').map(Number);
    if (!v1 || !v2 || v1.length !== 3 || v2.length !== 3) return false;
    //console.log("current", v1, "server", v2, "version", version);
    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const part1 = v1[i] || 0; // Default to 0 if part is missing (e.g., "1.2" vs "1.2.1")
      const part2 = v2[i] || 0;

      //console.log("part1", part1, "part2", part2);
      if (part2 > part1) return true;  // Available version is higher
      if (part2 < part1) return false; // Current version is already higher
    }

    return false; // Versions are identical
  };
  return (
    <>
      <Modal visible={showUserChoose}
        header={"Seleccione usuario"}
        size='small'
        onDismiss={() => setShowUserChoose(false)}
      >
      </Modal>
      <DemoHeaderPortal>
        <TopNavigation
          search={
            <>
              {data.userAirports && data.userAirports.length > 1 && idUser !== 0 && (
                <Select options={
                  data.userAirports ? data.userAirports.map((airport: any) => ({ value: airport.idAirport.toString(), label: `${airport.city} - ${airport.IATA} (${airport.idAirport})` })) : []
                }
                  selectedOption={
                    idAirport && data.userAirports ? { value: idAirport.toString(), label: `${data.userAirports.find((a: any) => a.idAirport === idAirport)?.city} - ${data.userAirports.find((a: any) => a.idAirport === idAirport)?.IATA}` } : null
                  }
                  onChange={(event) => {
                    //setParameters({ ...data, idAirport: event.detail.selectedOption ? Number(event.detail.selectedOption.value) : 0 })
                    setIdAirport(event.detail.selectedOption ? Number(event.detail.selectedOption.value) : 0)
                    handleChangeAirport(event.detail.selectedOption ? Number(event.detail.selectedOption.value) : 0)
                  }}
                />
              )}
            </>
          }
          identity={{
            href: '#home',
            logo: {
              src: 'resources/logo.png',
              alt: 'Logo',
            },
          }}
          utilities={visibleUtilities}
        />
        <TextContent>
          <div style={{ margin: 0, paddingLeft: 10, paddingBottom: 5, paddingTop: 3, backgroundColor: "#161d26", color: "white" }}>
            <small style={{ color: "white" }}>Versión {config.version} </small> {name && name !== "" && (<>| <small style={{ color: "white" }}><strong>{name}</strong> {isUpdateAvailable(config.version, version) && (<>| <Link onClick={() => setShowUpdate(true)}><Icon path={mdiAlert} size={0.75} color={"orange"} /></Link></>)} </small></>)}
          </div>
        </TextContent >

      </DemoHeaderPortal>
      {/*
      {topMessages && topMessages.length > 0 && (

        <TextContent><div style={{ backgroundColor: "#006ce0", color: "white", padding: 5, textAlign: 'center' }}>{topMessages[0].content}</div></TextContent>
      )}
        */}
      <AppLayoutToolbar
        notifications={
          <Flashbar items={flashbarItems} />
        }
        contentType='form'
        navigation={showNavigation ? <div ref={navRef}><SideNavigation activeHref={currentHash} items={navItems} /></div> : undefined}
        navigationOpen={showNavigation && navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        splitPanelPreferences={{
          position: 'side',
        }}

        onSplitPanelPreferencesChange={() => { }}
        {...props}
      />
      {loading && <LoadingOverlay />}
      <Modal visible={showBugReport}
        footer={
          <Box float="right">
            <Button variant="link" onClick={() => setShowBugReport(false)}>Cancelar</Button>
            <Button variant="primary" onClick={() => handleBugReport()}>Enviar reporte</Button>
          </Box>
        }
        header={<Header variant="h2"
          description={`Versión ${config.version}`}
        ><Icon path={mdiBugStopOutline} size={1} /> Notificar un error / bug</Header>}

        size='large'
        onDismiss={() => setShowBugReport(false)}

      >
        <SpaceBetween size="l" direction='vertical'>
          <FormField label="Error">
            <Textarea onChange={(detail) =>
              setBugReport((prev) => prev ? { ...prev, bug: detail.detail.value } : prev)
            }
              value={bugReport?.bug || ""}
              placeholder="Describa el problema aquí..."></Textarea>
          </FormField>
          <FileUpload
            onChange={({ detail }) => {
              const newFiles = detail.value.slice(0, 3);
              console.log(newFiles.length)
              setFiles(newFiles);
              handleFileChange(newFiles);
            }}
            accept="image/*"
            value={files}
            i18nStrings={{
              uploadButtonText: e =>
                "Agregar captura",
              dropzoneText: e =>
                "Arrastre archivo para cargar",
              removeFileAriaLabel: e =>
                `Eliminar archivo ${e + 1}`,
              limitShowFewer: "Show fewer files",
              limitShowMore: "Show more files",
              errorIconAriaLabel: "Error",
              warningIconAriaLabel: "Warning"
            }}
            multiple
            showFileSize
            showFileThumbnail
            fileTokenAlignment="horizontal"
            tokenLimit={3}
          />

          <FormField label="Routing">
            <Input readOnly value={window.location.hash} />
          </FormField>
          <SpaceBetween size="l" direction='horizontal'>
            <FormField label="Event Log">
              <ReactJsonView src={logHistory}
                name={false}
                style={{ minHeight: 300, minWidth: 300 }}
                collapsed={1}
                collapseStringsAfterLength={30}
                groupArraysAfterLength={10}
                displayObjectSize={false}
                displayDataTypes={false}
                enableClipboard={false}
              />
            </FormField>
            <FormField label="oParameters">
              <ReactJsonView src={parameters}
                name={false}
                style={{ minHeight: 300, minWidth: 300 }}
                collapsed={1}
                collapseStringsAfterLength={30}
                groupArraysAfterLength={10}
                displayObjectSize={false}
                displayDataTypes={false}
                enableClipboard={false}
              />
            </FormField>
          </SpaceBetween>
        </SpaceBetween>
      </Modal>
      <Modal visible={showUpdate}
        header={"Actualización disponible"}
        size='small'
        onDismiss={() => setShowUpdate(false)}

      >
        <Form actions={<Button variant="primary" onClick={() => window.location.reload()}>Actualizar ahora</Button>}>
          <p>Hay una nueva versión de la aplicación disponible. Por favor, actualice para obtener las últimas funciones y correcciones de errores.</p>
          <Container>
            <SpaceBetween size="m" direction="horizontal">
              <FormField label="Actual">
                {config.version}
              </FormField>

              <FormField label="&nbsp;">
                <Icon path={mdiWeatherCloudyArrowRight} size={1} />
              </FormField>
              <FormField label="Disponible">
                {version}
              </FormField>
            </SpaceBetween>
          </Container>

        </Form>
      </Modal>
    </>
  );
}

function menuContainsHref(menu: MenuItem[], href: string): boolean {
  for (const item of menu) {
    if (item.href === href) return true;
    if (item.items && menuContainsHref(item.items, href)) return true;
  }
  return false;
}

function getHashPath(hash: string): string {
  const questionMarkIndex = hash.indexOf('?');
  if (questionMarkIndex !== -1) {
    return hash.substring(1, questionMarkIndex);
  }
  return hash.substring(1);
}